<template>
    <div>
        <el-form-item label="">
            <el-tooltip placement="top" effect="light">
                <div slot="content">
                    <img src="/static/help/artistslist.png" alt="">
                </div>
                <el-button type="info" size="mini">
                    <i class="fa fa-question-circle"></i> Pomocnicze informacje dotyczące grafik
                </el-button>
            </el-tooltip>
        </el-form-item>
        <el-form-item label="Tło (motyw)"
                      :error="errors.image">
            <image-input-component v-model="form.image"/>
        </el-form-item>
        <el-form-item label="Film w tle"
                      :error="errors.background_video">
          <file-input-component v-model="form.background_video"/>
        </el-form-item>
        <div class="inline-form-group">
            <edition-input v-model="form.edition"
                           :errors="errors.edition"
                           :required="true"/>
            <el-form-item label="Tagi"
                          :error="errors.tags">
                <el-select filterable
                           v-model="form.tags"
                           multiple
                           placeholder="Tagi">
                    <el-option v-for="tag in availableTags"
                               :key="tag.id"
                               :label="tag.name"
                               :value="tag.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </div>
        <div class="inline-form-group">
            <el-form-item label="Sortowanie alfabetyczne">
                <el-switch v-model="form.alphabetical_order"/>
            </el-form-item>
            <el-form-item label="Doładowuj">
                <el-input type="number"
                          placeholder="Limit na start"
                          v-model="form.page_size"/>
                <small>Doładowywanie każdorazowo tyle elementów ile wynosi "limit na start"</small>
            </el-form-item>
        </div>
        <artists-preview :form="form"/>
    </div>
</template>
<script>
    import {Tag} from '@/api/'
    import ArtistsPreview from '@/components/widgets/forms/ArtistsListWidget/ArtistsPreview'
    import EditionInput from '@/components/EditionInput'

    export default {
        props: ["form", "errors"],
        data () {
            return {
                availableTags: [],
            }
        },
        mounted () {
            this.fetchData()
        },
        components: {
            ArtistsPreview,
            EditionInput
        },
        watch: {
            form (value) {
                if (value.tags === undefined) {
                    this.$set(this.form, 'tags', [])
                }
            }
        },
        methods: {
            fetchData () {
                this.$store.dispatch('fetchEditions')
                Tag.availableTags().then(response => {
                    const musicTags = response.data.find(obj => obj.label === 'music')
                    this.availableTags = musicTags.options
                })
            }
        }
    }
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// ArtistsListWidget.vue?3d455aaa